import React, { useContext } from 'react';
import InnerContentWrapper from 'pages/assessment/components/InnerContentWrapper';
import PreviewInvitationEmailButton from 'pages/assessment/candidate_invite/EmailInvitation/PreviewInvitationEmailButton';
import { assessmentSettingsCtx } from 'pages/assessment/store';
import InstructionToCandidateInput from './components/InstructionToCandidateInput';
import InvitationButtonInput from './components/InvitationButtonInput';

const InstructionToCandidates = ({ slug, audition, setSaving }) => {
    const { settings, setSettings } = useContext(assessmentSettingsCtx);

    return (
        <InnerContentWrapper
            header="Instruction to candidates"
            className="u-mrg--x0 u-pdn--x0 u-brdr--none"
            headerActions={(
                <PreviewInvitationEmailButton
                    className="u-mrg--rx2"
                    audition={audition}
                    text="Preview and edit invitation email"
                />
            )}
        >
            <InstructionToCandidateInput
                slug={slug}
                defaultValue={settings.message}
                setSaving={setSaving}
                setSettings={setSettings}
            />
            <InvitationButtonInput
                slug={slug}
                defaultValue=""
                setSaving={setSaving}
            />
        </InnerContentWrapper>
    );
};

export default InstructionToCandidates;
